import React, {useState, useEffect} from "react";
import {SingleDatePicker} from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./App.css";
import moment from "moment";
import "moment/locale/de";
function App() {
  const [date, setDate] = useState(null);
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    moment.locale("de");
  }, []);
  return (
    <>
      <SingleDatePicker
        date={date}
        onDateChange={date => setDate(date)}
        focused={focused}
        onFocusChange={({focused}) => setFocused(focused)}
        showClearDate
        reopenPickerOnClearDate
        noBorder
        block
        placeholder="Datum*"
        numberOfMonths={1}
        autoFocus
        displayFormat="DD.MM.YYYY"
        readOnly
      />
      <input
        type="text"
        name="fw-lordz-date"
        value={date ? new Date(date) : ""}
        onChange={() => {}}
        style={{display: "none"}}
      />
    </>
  );
}

export default App;
